import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppInstalableService } from './core/services/app-instalable.service';
import { MiVendedorService } from './core/services/mi-vendedor.service';
import { InvitarInstalarComponent } from './shared/ui/instalar-app/invitar-instalar.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, InvitarInstalarComponent],
  template: '<router-outlet /><app-invitar-instalar />',
})
export class App {
  constructor() {
    // D-178: Safari del iPhone ignora user-scalable=no; se corta el gesto de pellizcar
    if (typeof document !== 'undefined') document.addEventListener('gesturestart', (e) => e.preventDefault(), { passive: false });
    // Service worker de las notificaciones push e invitación a instalar la app (D-147)
    inject(AppInstalableService).iniciar();
    // El vendedor del link (?v=CODIGO), D-149
    inject(MiVendedorService).iniciar();
  }
}
